import './detail.css'

export {
  DetailPageHead,
  DetailButton,
  DetailKpiCard,
  DetailKpiGrid,
  DetailAccordion,
  DetailInfoItem,
  DetailInfoGrid,
  DetailPanel,
  DetailProse,
  DetailDashGrid,
  DetailSectionBar,
  DetailEmptyState,
  DetailTable,
  DetailEntityPanel,
} from './DetailPrimitives'
export type { DetailColumn } from './DetailPrimitives'
export { RelatedActionsPanel } from './RelatedActionsPanel'
export { DetailDescriptionPanel } from './DetailDescriptionPanel'
export { DetailTabs } from './DetailTabs'
export type { DetailTabItem } from './DetailTabs'
